import { withInstall } from '@jdesign-vue/utils'
import Row from './src/row.vue'

export const JdRow = withInstall(Row)
export default JdRow

export * from './src/row'
export * from './src/constants'
